import { render, staticRenderFns } from "./cashier-template-widget.vue?vue&type=template&id=4b5a3ee9&"
import script from "./cashier-template-widget.vue?vue&type=script&lang=js&"
export * from "./cashier-template-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports